import request from '@/utils/request'
import type { ApiResponse, TermItem, QueryParams, PageResult } from '@/types/term'

// 获取术语列表
export function listTermByPage(query: QueryParams) {
  return request<ApiResponse<PageResult<TermItem>>>({
    url: '/admin/term',
    method: 'get',
    params: query
  })
}

// 获取术语详情
export function getTermById(id: string) {
  return request<ApiResponse<TermItem>>({
    url: `/admin/term/${id}`,
    method: 'get'
  })
}

// 定义查询参数接口
interface TermQueryParams {
  id:  number;
}

// 获取术语列表
export function getTermsByStandardId(config: any) {
  return request({
    url: '/admin/term/byStandardId',
    method: 'get',
    ...config // 这样可以正确传递 query 参数
  })
}

// 新增术语请求接口
export interface AddTermRequest {
  cName?: string
  eName?: string
  explanation?: string
  imageList?: string[]
  standardId: number
}

// 新增术语
export function addTerm(data: TermItem) {
  return request<ApiResponse<any>>({
    url: '/admin/term',
    method: 'post',
    data
  })
}

// 修改术语
export function updateTerm(data: TermItem) {
  return request<ApiResponse<any>>({
    url: '/admin/term',
    method: 'put',
    data
  })
}

// 删除术语
export function deleteTerm(id: string) {
  return request<ApiResponse<any>>({
    url: `/admin/term/${id}`,
    method: 'delete'
  })
}

// 批量删除术语
export function deleteTermBatch(ids: string[]) {
  return request<ApiResponse<any>>({
    url: '/admin/term/batch',
    method: 'delete',
    data: ids
  })
} 